import classNames from 'classnames'
import Container from '../Container'
import Typography from '../Typography'
import StyledProcessFlowCircle from './StyledProcessFlowCircle/StyledProcessFlowCircle'
import StyledProcessFlowDivider from './StyledProcessFlowDivider/StyledProcessFlowDivider'

import { ProcessFlowProps, ProcessFlowStatus } from './types'

const ProcessFlow = ({
    steps,
    activeStep,
    size = 'md',
    direction = 'vertical',
    color
}: ProcessFlowProps) => {
    const isVertical = direction === 'vertical'
    const titleVariant = size === 'md' ? 'HM4' : 'P3'

    const renderVerticalStep = (
        step: { title: string; subtitle?: string },
        status: ProcessFlowStatus,
        isLastStep: boolean
    ) => (
        <>
            <Container className='flex flex-column mr-4 flex-middle'>
                <StyledProcessFlowCircle
                    status={status}
                    size={size}
                    color={color}
                />
                {!isLastStep && (
                    <StyledProcessFlowDivider
                        status={status}
                        direction='vertical'
                        size={size}
                        color={color}
                    />
                )}
            </Container>

            <Container className='flex flex-column flex-1'>
                <Typography variant={titleVariant}>{step.title}</Typography>
                {step.subtitle && (
                    <Typography
                        variant='P3'
                        className='mt-2 mb-4'
                        color='subheading'
                    >
                        {step.subtitle}
                    </Typography>
                )}
            </Container>
        </>
    )

    const renderHorizontalStep = (
        step: { title: string; subtitle?: string },
        status: ProcessFlowStatus,
        isLastStep: boolean
    ) => (
        <>
            <Container
                className={`flex flex-column flex-middle ${isLastStep ? '' : ''}`}
            >
                <StyledProcessFlowCircle
                    status={status}
                    size={size}
                    color={color}
                />
                <Container className='flex flex-column flex-1' width='70px'>
                    <Typography variant={titleVariant} className='ta-c mt-1'>
                        {step.title}
                    </Typography>
                </Container>
            </Container>

            {!isLastStep && (
                <StyledProcessFlowDivider
                    status={status}
                    direction='horizontal'
                    size={size}
                    color={color}
                />
            )}
        </>
    )

    return (
        <Container
            className={classNames('flex', {
                'flex-row': direction === 'horizontal',
                'flex-column': direction === 'vertical'
            })}
        >
            {steps.map((step, index) => {
                const isLastStep = index === steps.length - 1
                const status =
                    index < activeStep
                        ? 'COMPLETED'
                        : index === activeStep
                          ? 'CURRENT'
                          : 'UPCOMING'

                return (
                    <Container
                        key={`step-${index}`}
                        className={classNames('flex p-relative', {
                            'flex-1': !isLastStep
                        })}
                    >
                        {isVertical
                            ? renderVerticalStep(step, status, isLastStep)
                            : renderHorizontalStep(step, status, isLastStep)}
                    </Container>
                )
            })}
        </Container>
    )
}

export default ProcessFlow
